import styled from 'styled-components'
import { Edit } from '@material-ui/icons'

export const Container = styled.div``
export const Title = styled.h1`
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  color: #666666;
`

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-flow: dense;
  gap: 24px;
  width: 100%;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  border: 1px solid ${(props) => props.theme.colors.scale[500]};
  border-radius: 5px;
  background: #fff;
`

export const Header = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background: #fff;
  padding: 8px 0;
  z-index: 1;
`

export const PlanTable = styled.div`
  border: 1px solid ${(props) => props.theme.colors.scale[500]};
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  border-radius: 5px;
  flex: 1;
  height: 100%;
  min-width: 100%;
  width: 100%;
`
export const PlanTableHead = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.colors.scale[500]};
  flex: 1;
  width: 100%;
  display: grid;
  font-weight: bold;
  grid-template-columns: 100px repeat(${(props) => props.totalPlans}, 1fr);
`

export const PlanTableHeadItem = styled.div`
  flex-wrap: wrap;
  border: none;
  display: flex;
  width: 100%;
  border-right: 1px solid ${(props) => props.theme.colors.scale[500]};
  border-left: 1px solid transparent;
  &:last-child {
    border-right: none;
    padding-right: 1px;
  }
`
export const PlanTableHeadItemTitle = styled.h3`
  padding: 8px;
  width: 100%;
  margin: 0;
  padding: 10px 10px 4px 10px;
  text-align: center;
`

export const PlanTableHeadItemDescription = styled.div`
  border: none;
  padding: 0px 8px 4px 8px;
  display: flex;
  flex: 1;
  width: 100%;
  &:last-child {
    border: none;
  }
`

export const HeadInputBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4px 8px;
  box-sizing: border-box;
  & > div {
    width: 100%;
    max-width: 80px;
  }
`

export const HeadInputSuffix = styled.span`
  font-size: 12px;
  color: #666;
  white-space: nowrap;
`

export const HeadInputLabel = styled.span`
  display: block;
  width: 100%;
  text-align: center;
  font-size: 10px;
  line-height: 1;
  color: #666;
  margin-bottom: 4px;
`

export const PlanTableBody = styled.div`
  flex: 1;
  width: 100%;
  display: grid;
  grid-template-columns: 100px repeat(${(props) => props.totalPlans}, 1fr);
  flex-wrap: wrap;
`

export const PlanTableFooter = styled.div`
  border-top: 1px solid ${(props) => props.theme.colors.scale[500]};
  width: 100%;
  display: grid;
  grid-template-columns: 100px repeat(${(props) => props.totalPlans}, 1fr);
  align-items: center;
`

export const PlanTableTop = styled.div`
  border: 1px solid ${(props) => props.theme.colors.scale[500]};
  border-radius: 5px;
  width: 100%;
  display: grid;
  grid-template-columns: 100px repeat(${(props) => props.totalPlans}, 1fr);
  align-items: center;
  padding: 4px 0;
  gap: 0;
  margin-bottom: 8px;
  background: #fafafa;
`

export const FooterLabelCell = styled.div`
  padding: 6px 10px;
  font-size: 12px;
  color: #666;
  font-weight: 500;
  border-right: 1px solid ${(props) => props.theme.colors.scale[500]};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`

export const FooterCell = styled.div`
  padding: 6px 10px;
  border-right: 1px solid ${(props) => props.theme.colors.scale[500]};
  display: flex;
  justify-content: center;
  align-items: center;
  &:last-child { border-right: none; }
  transition: background-color 0.2s ease;
  &.modified {
    background-color: #fff8e1;
  }
`

export const DivisorInputBox = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  max-width: 160px;
  & > span { font-size: 12px; color: #666; }
`

export const PlanTableLine = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  padding: 0;
  border-right: 1px solid ${(props) => props.theme.colors.scale[500]};
  &:last-child {
    border: none;
  }
`

export const PlanTableItem = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  border-bottom: 1px solid ${(props) => props.theme.colors.scale[500]};
  &:last-child {
    border: none;
  }
  & > h3 {
    padding: 8px;
    margin: 0;
    font-size: 16px;
  }
  & > p {
    padding: 8px;
    margin: 0;
    flex: 1;
    border-right: 1px solid ${(props) => props.theme.colors.scale[500]};
    display: flex;
    align-items: center;
    min-height: 40px;
    &:last-child {
      border: none;
    }
    &.modified {
      background-color: #fff3cd;
      border-left: 4px solid #ffc107;
    }
    strong {
      font-weight: 500;
    }
  }
`

export const PlanConfiguration = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  border-radius: 5px;
  width: 100%;
  height: 100%;
`

export const PlanConfigurationDescription = styled.p`
  margin: 0;
`

export const PlanConfigurationList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 350px;
  padding: 0;
`
export const PlanConfigurationItem = styled.li`
  list-style: none;
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  gap: 8px;
  min-width: fit-content;
  width: 100%;
  .fix {
    min-width: 170px;
  }
`

export const Actions = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  gap: 12px;
  align-items: center;
`

export const Legend = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #555;
  background: #f4f6f8;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  padding: 6px 10px;
  white-space: nowrap;
`

export const Warning = styled.em`
  color: ${(props) => props.theme.colors.error};
  font-size: 12px;
`

export const HelperText = styled.p`
  margin: 8px 0 0;
  font-size: 12px;
  color: #666;
`

export const HelperBlock = styled.div`
  display: grid;
  gap: 4px;
  margin-top: 8px;
  font-size: 12px;
  color: #555;
  p { margin: 0; }
  strong { font-weight: 600; }
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`

export const DiscardButton = styled.button`
  background: transparent;
  color: #ff8c00;
  border: 1px solid #ff8c00;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: #ff8c00;
    color: #fff;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const ValueColumn = styled.p`
  padding: 8px;
  margin: 0;
  flex: 1.5;
  min-width: 120px;
  border-right: 1px solid ${(props) => props.theme.colors.scale[500]};
  white-space: nowrap;
  position: relative;
  transition: background-color 0.2s ease;
  
  &.editing {
    background-color: #f8f9fa;
    border: 2px solid #007bff;
    border-radius: 4px;
  }
  
  strong {
    font-weight: 500;
  }
`

export const BathColumn = styled.p`
  padding: 8px;
  margin: 0;
  flex: 1;
  border-right: 1px solid ${(props) => props.theme.colors.scale[500]};
  &:last-child {
    border: none;
  }
`

export const EditContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`

export const ValueSelect = styled.select`
  flex: 1;
  min-width: 120px;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
  padding-right: 32px;
  
  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
  
  &:hover {
    border-color: #007bff;
    background-color: #f8f9fa;
  }
`

export const ActionButton = styled.button`
  border: none;
  border-radius: 4px;
  padding: 6px 10px;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  transition: all 0.2s ease;
  min-width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &.save {
    background: #28a745;
    color: white;
    
    &:hover {
      background: #218838;
      transform: scale(1.05);
    }
  }
  
  &.cancel {
    background: #dc3545;
    color: white;
    
    &:hover {
      background: #c82333;
      transform: scale(1.05);
    }
  }
`

export const ValueDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`

export const EditIcon = styled(Edit)`
  cursor: pointer;
  font-size: 16px;
  color: #666;
  transition: all 0.2s ease;
  
  &:hover {
    color: #007bff;
    transform: scale(1.1);
  }
  
  &.disabled {
    color: #ccc;
    cursor: not-allowed;
    
    &:hover {
      color: #ccc;
      transform: none;
    }
  }
`